import Button from 'react-bootstrap/Button';
import { useAuth0 } from '@auth0/auth0-react';

const LoginPage = () => {
  const { loginWithRedirect } = useAuth0();

  return (
    <div className='d-flex justify-content-center align-items-center' style={{ minHeight: '70vh' }}>
      <div className='text-center' style={{ maxWidth: 360 }}>
        <div className='mb-4' style={{ fontSize: '1rem', fontWeight: 500 }}>
          Log in or create an account to use Lexio.
        </div>
        <Button
          variant='secondary'
          size='lg'
          style={{
            background: '#7a41ca',
            borderRadius: 10,
            minWidth: 250,
            paddingTop: '0.55rem',
            paddingBottom: '0.55rem',
            fontSize: '0.9rem',
            fontWeight: 500,
            letterSpacing: '0.04em',
          }}
          onClick={() => {
            loginWithRedirect({ appState: { returnTo: '/' } });
          }}
        >
          Log in to davelyo.com
        </Button>
      </div>
    </div>
  );
};

export default LoginPage;
